<template>
  <el-dialog
    class="myDialog"
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
    :top="top"
    @close="dialogClose"
    @open="dialogOpen"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-dialogDrag
  >
    <slot name="content"></slot>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="title && title.startsWith('烧录工单【') && !title.endsWith('】检验通过')" @click="$emit('rollBack')"  class="roll_back_btn" size="small">强制跳过烧录校验</el-button>
      <el-button v-if="title=='修改工序'" @click="$emit('rollBack')"  class="roll_back_btn" size="small">还原默认配置</el-button>
      <el-button v-if="title=='修改版本配置'" @click="$emit('rollBack')"  class="roll_back_btn" size="small">还原默认配置</el-button>
      <el-button class="cancelBtn" @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="$emit('submitData', title)" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    width: {
      type: String,
      default: "500px"
    },
    top: {
      type: String,
      default: "50vh"
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    dialogOpen() {},
    dialogClose() {
      this.$emit("dialogClose", this.title);
      document.querySelectorAll(".el-dialog").forEach(item => {
        setTimeout(() => {
          item.style.left = "0";
          item.style.top = "0";
        }, 500);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-footer {
  display: block;
  padding-top: 10px;
  margin-right: 10px;
}

// 次按钮（取消）跟随主题色：默认白底主题色边框，悬停时变为主题浅底/浅边框，
// 比实底主题色的主按钮淡一档；按压时文字/边框加深
.dialog-footer .cancelBtn {
  color: var(--themeColor);
  background-color: var(--bgPanel);
  border-color: var(--themeColor);

  &:focus,
  &:hover {
    color: var(--themeColor);
    background-color: var(--themeLightBg);
    border-color: var(--themeLightBorder);
  }

  &:active {
    color: var(--themeColorDark);
    border-color: var(--themeColorDark);
  }
}
</style>